import React from 'react';
import { Input, Label } from 'reactstrap';

function RadioType({ answers = [] }) {
  return (
    <>
      {
        answers.map((i, k) => (
          <span key={k} className='mx-1'>
            <Input type='radio' readOnly checked={i.answer !== null} disabled />
            <Label className='ms-1'>{i.label}</Label>
          </span>

        ))
      }

    </>
  );
}

export default RadioType;